"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MC_BANNER_CLOSED = void 0;

var _prefix = function _prefix(key) {
  return "CBX:" + key;
};

var MC_BANNER_CLOSED = _prefix('MCBannerClosed');

exports.MC_BANNER_CLOSED = MC_BANNER_CLOSED;